import { MONEY_SYMBOL } from 'modules/core/constants';
import React from 'react';

export const DollarAdornment: React.FC = () => <span>{MONEY_SYMBOL}</span>;
